import { mainColor, UNIT } from '../../constants/theme';

export const styles = theme => ({
  root: {
    overflowX: 'auto'
  },
  heading: {
    fontSize: UNIT * 0.75,
    minWidth: UNIT * 4.375,
    textAlign: 'center',
    fontWeight: 'bolder'
  },
  orderRow: {
    fontSize: UNIT * 0.6875,
    flexShrink: 0,
    minWidth: UNIT * 4.5,
    textAlign: 'center',
    color: 'black !important'
  },

  arrow: {
    padding: '3px 0px 0px 0px'
  },
  margeDetail: {
    flexBasis: '4%',
    flexShrink: 0
  },
  detail: {
    fontSize: UNIT * 0.75
  },

  table: {
    minWidth: 200,
    overflowX: 'auto'
  },
  progress: {
    margin: theme.spacing.unit * 15
  },
  icon: {
    fontSize: UNIT * 1.5,
    color: 'black'
  },
  iconButton: {
    position: 'relative',
    right: '7px'
  },
  typoDetails: {
    fontSize: UNIT * 0.75,
    color: mainColor.colorBlack,
    display: 'inline-block'
  },
  circularProgress: {
    textAlign: 'center',
    color: `rgba(${mainColor.red}, ${mainColor.green}, ${mainColor.blue}, 1)`
  },
  hrStyle: {
    border: '0',
    height: '1px',
    backgroundImage:
      'linear-gradient(to right, rgba(200, 200, 200, 0.5), rgba(200, 200, 200, 0.75), rgba(200, 200, 200, 0.5))'
  },

  orderDetail: {
    color: mainColor.colorBlackLight,
    fontSize: '14px'
  },
  subtitle: {
    fontWeight: 'bolder'
  },
  colStyle: { minWidth: '300px', padding: '10px' },
  labelStyle: {
    fontSize: UNIT * 0.75,
    color: mainColor.colorBlack,
    minWidth: '70px',
    justifyContent: 'center',
    display: 'inline-block'
  },
  rowTitle: {
    flexdirection: 'row',
    justifyContent: 'flex-start',
    display: 'inline-block',
    margin: '-12px 0px 0px 0px',
    width: '100%'
  },
  orderCol: { margin: '10px', minWidth: '200px' },
  content: {
    alignItems: 'center',
    width: '100%'
  },
  paperStyle: {
    padding: '20px',
    border: '1px solid #B5B3B3',
    height: '100%'
  }
});
